

<div [className]="'login_Login'">
  <form class="form-signin text-center change_force_p">
    <div>
      <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200">
    </div>
    <div #container></div>
    <span id="MainContent_diverror" class="error-message">{{this.authService.error | translate}}</span>

    <label for="inputEmail" class="sr-only">{{ 'Login.EmailaddressSr' | translate }}</label>
    <input type="text" id="inputEmail" class="form-control" readonly="readonly" placeholder="{{ 'Login.UserName' | translate }}" #userName="ngModel" name="userName" asp-for="Username" [(ngModel)]="user.userName" required autofocus>
    <label for="inputPassword" class="sr-only">{{ 'Login.PasswordSr' | translate }}</label>
    <app-password-input [(ngModel)]="user.oldPassword"
      name="oldPassword"
      id="inputOldPassword"
      required
      [placeholder]="'Login.OldPassword' | translate"
      data-test-id="txt-old-password"
      className="password-icon">
    </app-password-input>
    <app-password-input [(ngModel)]="user.password"
      name="password"
      id="inputPassword"
      [placeholder]="'New Password'"
      [maxlength]="25"
      required
      (keyup)="checkIfMatchingPasswords($event)"
      data-test-id="txt-new-password"
      className="password-icon">
    </app-password-input>

    <app-password-input [(ngModel)]="user.confirmPassword"
      name="password"
      id="inputPassword"
      [placeholder]="'Confirm New Password'"
      required
      (byKeyup)="checkIfMatchingPasswords($event)"
      data-test-id="txt-confirm-password"
      className="password-icon">
    </app-password-input>
    <div style="text-align:left;margin-top: -20px;">
      @if (submittedApplicationForm && notEquivalent ) {
        <label class="text-danger">{{ 'Common.Passworddoesnotmatch' | translate }}</label>
      }
    </div>
    <div style="text-align:left;margin-left:-15px;padding-top:15px">
      @if (user.password) {
        <password-strength-meter [password]="user.password"
          (strengthChange)="strengthChanged()">
        </password-strength-meter>
      }
    </div>

    @if (user.password) {
      <label class="text-danger" style="text-align:left;">{{common.message}}</label>
    }

    @if (isPasswordBreached) {
      <div>
        <app-pwned-password-instructions></app-pwned-password-instructions>
      </div>
    }
    <button class="btn btn-lg btn-primary btn-block btn_login" (click)="Save()">{{ 'Common.ChangePassword' | translate }}</button>
    <br />
    <p class="text-muted">&copy; {{ 'Login.Footer' | translate }}</p>
  </form>
</div>

